import { lazy } from "react";

export default {
  name: "Safety",
  path: "/safety",
  component: lazy(() => import("./index"))
}